import styles from "./Title.module.scss";

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export default function Title({ children }: Props) {
  return <h1 className={styles.title}>{children}</h1>;
}
